import { useSelector } from 'react-redux';
import SlideCard from '../common/SlideCard';

export function SellerAutoSync() {
  const { autoSync } = useSelector((state) => state.operators.configuration);

  return (
    <SlideCard
      title="Automatic Product Listing"
      description="If enabled, all products approved to this operator will be automatically listed on the operator's platform."
    >
      {autoSync ? 'Enabled' : 'Disabled'}
    </SlideCard>
  );
}
